import styled, { css } from "styled-components";
import { CheckboxGroup as CheckboxGroupPrimitive } from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

export const CheckboxGroup = styled(CheckboxGroupPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { checkboxGroup } = tokens;

    return css`
      display: grid;
      gap: ${checkboxGroup.list.gap};
    `;
  }}
`;
